<div class="content-wrapper table-full-bx">
	<div class="account-settings">
		<div class="row">
			<div class="col-lg-12">
				<div class="ibox ">
					<div class="ibox-body">
						<div class="iboxcontent">
							<h3>Account Settings</h3> </div>
						<!-- Account settings  -->
						<div class="row">
							<div class="col-md-12 col-lg-3  col-sm-12">
								<!-- Tabs nav -->
								<div class="nav nav-pills nav-pills-custom pills-custom">
									<a class="nav-link mb-3 p-3 " href="javascript:void(0);" routerLink="/account-settings/change-password"> <span class=" ">Change password</span> </a>
									<a class="nav-link mb-3 p-3  " href="javascript:void(0);" routerLink="/account-settings/notification"> <span class=" ">Notifications</span> </a>
									<a class="nav-link mb-3 p-3 " href="javascript:void(0);" routerLink="/account-settings/save-card" hidden> <span class=" ">Saved cards</span> </a>
									<a class="nav-link mb-3 p-3  active" href="javascript:void(0);" routerLink="/account-settings/inventory-history"> <span class="">Subscriptions</span> </a>
									<a class="nav-link mb-3 p-3 " href="javascript:void(0);" routerLink="/account-settings/billing-address"> <span class=" ">Billing address</span> </a>
									<a class="nav-link mb-3 p-3  " href="javascript:void(0);" routerLink="/account-settings/my-templates"> <span class=" ">My templates</span> </a>
								</div>
							</div>

							<!--  -->
							<div class="col-md-12 col-lg-9">
								<section class=" subscription">
									<ul class="nav nav-pills sub">
										<li class="active">
											<a href="javascript:void(0)" routerLink="/account-settings/subscription/subscription-plan"> Subscription plans</a>
										</li>
										<li ><a href="javascript:void(0)" routerLink="/account-settings/inventory-history/inventory-plan"> Inventory purchase </a></li>
									</ul>

									<p class="para"> Buy a plan that works best for you </p>
									<div class="row plan">
										<!-- First Card -->
										<div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12" *ngFor="let plan of allPlans; let i=index;">
											<div class="card-grid-2 hover-up" (click)="highlight(plan)" [ngClass]="getRowClass(plan)">
												<!--  selected -->
												<div class="pill"><span> {{plan.planName}} </span></div>
												<div class="card-block-info">
													<h6 class="orangetext">${{plan.planAmount}} <span>/ {{plan.validity < 2 ? (plan.validity + (" "+plan.validityType)) :  (plan.validity + (" "+plan.validityType +'s'))}}</span></h6>
													<div class="mt-3" *ngIf="plan.concurrentJobsAssignedEachPlan">
														<p>{{plan.concurrentJobsAssignedEachPlan}} </p>
													</div>
													<ul class="planlist checkmark">
														<li><span>{{plan.numberOfJob}}</span> Job posting for  <span>{{plan.validity < 2 ? (plan.validity + (" "+plan.validityType)) :  (plan.validity + (" "+plan.validityType +'s'))}}</span></li>
                										<li><span>{{plan.numberOfView}}</span> Resume views</li>
														<li><span>{{plan.numberOfClicks}}</span> Number of Clicks</li>
													</ul>
													<div class="choose">
														<a href="javascript:void(0);" class="planbtn" [routerLink]="'/account-settings/checkout/subscription/'+plan.id">Choose plan</a>
														<a href="javascript:void(0);" class="planbtn fill" [routerLink]="'/account-settings/checkout/subscription/'+plan.id">Selected</a>
													</div>
												</div>
											</div>
											<!--Main card div  -->
										</div>
										<!-- End -->
									</div>
								</section>

								<footer class="footer-subscription" hidden>
									<div class="row">
										<div class="col-md-6 ">
											<div class="icon"><img src="assets/images/ic_cart.svg"></div>
											<div class="massage-sect">
												<p> Selected : {{allInventoryPlans?.planName}} Plan {{allInventoryPlans?.validity}} </p>
												<h6> ${{allInventoryPlans?.planAmount}} (excluding taxes) </h6>
											</div>
										</div>
										<div class="col-md-6 text-right">
											<a href="javascript:void(0);" routerLink="/account-settings/subscription/checkout" class="commonBtn2 continuebtn"> Continue </a>
										</div>
									</div>
								</footer>
							</div>
							
						</div>
						<!-- End -->
					</div>
				</div>
			</div>

		</div>
	</div>
</div>